import classcat from "classcat";
import React from "react";

import { IconLeft, IconRight } from "@touchtech/web-baselayer-ui";

import { Logo } from "@is/components/Logo";
import Stepper from "@is/components/Stepper";
import { STEPS_TITLES } from "@is/constants";

import css from "./Registration.module.css";
import useManageRegistration from "./hooks/useManageRegistration";

const Registration = () => {
  const {
    steps,
    activeStep,
    activeStepIndex,
    isNextStepAllowed,
    handleStepChange,
    ActiveStepComponent,
    handleNextStep,
    handlePreviousStep,
  } = useManageRegistration();

  return (
    <div className={css.container}>
      <div className={css.header}>
        <h1 className="text-headline-5xl">{STEPS_TITLES()[activeStep.key]}</h1>
        <Stepper
          steps={steps}
          currentStepIndex={activeStepIndex}
          onStepChange={handleStepChange}
        />
      </div>
      <div className={css.content}>
        <button
          className={classcat([css.navigationButton])}
          onClick={handlePreviousStep}
        >
          <IconLeft className="text-label-3xl" />
        </button>
        <ActiveStepComponent />
        <button
          className={classcat([
            css.navigationButton,
            { [css.disabled]: !isNextStepAllowed },
          ])}
          onClick={handleNextStep}
          disabled={!isNextStepAllowed}
        >
          <IconRight className="text-label-3xl" />
        </button>
      </div>
      <Logo />
    </div>
  );
};

export default Registration;
